module.exports = __webpack_public_path__ + "04_short_brown.59b384d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/boy/layer5/04_short_brown.png
// module id = fx6n
// module chunks = 0